export const fetchLayerDetailsFromXML = (xmlString: string) => {
  const parser = new DOMParser();
  const xml = parser.parseFromString(xmlString, 'application/xml');

  const ns = xml.documentElement.lookupNamespaceURI(null);

  const layerNodes = xml.getElementsByTagNameNS(ns, 'Layer');

  const layerNames = [];

  for (const layer of layerNodes) {
    const nameEl = layer.getElementsByTagNameNS(ns, 'Name')[0];
    const titleEl = layer.getElementsByTagNameNS(ns, 'Title')[0];
    const descEl = layer.getElementsByTagNameNS(ns, 'Abstract')[0];
    if (nameEl && nameEl?.textContent?.trim()) {
      layerNames.push({
        name: nameEl?.textContent?.trim() as string,
        title: titleEl?.textContent?.trim() as string,
        description: descEl?.textContent?.trim() as string,
      });
    }
  }

  return layerNames;
};
